<template>
  <div>
    <el-dialog
      custom-class="loading-box"
      :visible.sync="centerDialogVisible"
      :width="!$store.getters.isPC ? '90%' : '40%'"
      center
      @close="close"
      :show-close="true"
    >
      <div class="loading-icon">
         <slot></slot> 
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    centerDialogVisible: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '40%'
    },
  },
  methods:{
    close(){
      this.$emit('close',false)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .loading-box {
    border-radius: 10px;
  }
}
.loading-icon {
  font-size: 55px;
  text-align: center;
}
.loading-text {
  font-size: 20px;
}
</style>
